//Login Handler Reducer

const loginHandlerReducerDefaultState = {
    isAuthorized : ''
};

export default (state = loginHandlerReducerDefaultState, action) => {
    switch(action.type) {
        case 'SET_AUTHORIZED_STATE':
            return {
                ...state,
                isAuthorized : action.payload
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/Reducers/loginHandler.js